import InfoLayout from "./InfoLayout";

function Disclaimer() {
    return (
        <InfoLayout title="Disclaimer">
            <div>
              <h2>Pečlivost vývoje</h2>
                <p>
                    Aplikaci <strong>Tabata časovač</strong> vyvíjíme s maximální pečlivostí a snahou o spolehlivost, 
                    aby byla užitečným nástrojem pro vaše cvičení. Přesto nelze zaručit, že bude vždy fungovat 
                    bez chyb, výpadků nebo technických problémů.
                </p>

                <h2>Bezpečnost a odpovědnost</h2>
                <p>
                    Veškerá cvičení provádíte na vlastní riziko. Aplikace slouží pouze jako pomocný nástroj 
                    pro sledování vašich tréninků, plánování intervalů a zlepšování výkonu. Nenahrazuje 
                    osobního trenéra ani lékařskou konzultaci. Doporučujeme cvičit uvážlivě a přizpůsobit cviky svým možnostem, protože každý je zodpovědný za své vlastní zdraví a bezpečnost.
                </p>

                <h2>Omezení odpovědnosti</h2>
                <p>
                    Provozovatel nenese odpovědnost za žádné škody, zranění, ztrátu dat, ztrátu času nebo jiné 
                    následky vzniklé používáním aplikace. Doporučujeme cvičit uvážlivě a přizpůsobit intenzitu 
                    vašim fyzickým možnostem.
                </p>

                <h2>Externí odkazy</h2>
                <p>
                    Aplikace může obsahovat odkazy na externí weby třetích stran. Pro obsah těchto webů 
                    nenese provozovatel žádnou odpovědnost, stejně jako za jejich funkčnost nebo bezpečnost.
                </p>

                <h2>Žádné garance</h2>
                <p>
                    Provozovatel negarantuje, že aplikace bude vždy dostupná, bez chyb, přerušení nebo omezení 
                    funkcí. Mohou nastat krátkodobé výpadky, plánovaná údržba nebo nečekané technické problémy, 
                    které mohou ovlivnit její dostupnost či funkčnost.
                </p>

                <h2>Souhlas s podmínkami</h2>
                <p>
                    Používáním této aplikace potvrzujete, že jste si přečetli, porozuměli a souhlasíte s tímto 
                    prohlášením o vyloučení odpovědnosti. Doporučujeme si tyto podmínky pečlivě přečíst 
                    před pravidelným používáním aplikace.
                </p>
            </div>
        </InfoLayout>
    );
}

export default Disclaimer;
